var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  align-items: flex-end;\n  min-height: 215px;\n  ', '\n  padding: 20px;\n  ', '\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n'], ['\n  display: flex;\n  align-items: flex-end;\n  min-height: 215px;\n  ', '\n  padding: 20px;\n  ', '\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: cover;\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  opacity: 0.9;\n  background-image: ', ';\n  @media (max-width: 576px) {\n    padding: 20px;\n  }\n'], ['\n  position: relative;\n  opacity: 0.9;\n  background-image: ', ';\n  @media (max-width: 576px) {\n    padding: 20px;\n  }\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  cursor: ', ';\n  top:0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-image: ', ';\n'], ['\n  position: absolute;\n  cursor: ', ';\n  top:0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background-image: ', ';\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import profileImgSVG from '../../assets/img/profileImg.svg';
var BaseProfileImage = styled.div(_templateObject, function (_ref) {
  var fluid = _ref.fluid;
  return fluid ? 'width: 100%;' : 'min-width: 306px;';
}, function (_ref2) {
  var square = _ref2.square;
  return square && 'padding: 0px 0px 100% 0px; min-width: 215px;';
});
var ProfileImage = styled(BaseProfileImage)(_templateObject2, 'url(' + profileImgSVG + ')');
var ProfileImageBox = styled(BaseProfileImage)(_templateObject3, function (_ref3) {
  var onClick = _ref3.onClick;
  return onClick ? 'pointer' : 'default';
}, function (props) {
  return 'url(' + props.photo + ')';
});
ProfileImage.displayName = 'ProfileImage';
ProfileImage.propTypes = {
  photo: PropTypes.string,
  fluid: PropTypes.bool
};
export default (function (_ref4) {
  var fluid = _ref4.fluid,
    square = _ref4.square,
    photo = _ref4.photo,
    vertical = _ref4.vertical,
    children = _ref4.children,
    onClick = _ref4.onClick;
  return React.createElement(ProfileImage, {
    fluid: fluid,
    square: square,
    vertical: vertical
  }, photo ? React.createElement(ProfileImageBox, {
    'data-testid': 'profile-img-box',
    onClick: onClick,
    photo: photo,
    fluid: fluid
  }) : null, children);
});